import React, { useState } from "react";
import { TextField } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import { server } from "../../common";
import { useDispatch } from "react-redux";

const initialValues = {
  merchant_name: "",
  merchant_email: "",
  merchant_mobile: "",
  password: "",
  image: null,
};

const MerchantRegister = () => {
  document.title = "Register";
  const [step, setStep] = useState(0);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      merchant_name: Yup.string()
        .min(2, "Please enter a Name")
        .required("Please enter Merchant Name"),
      merchant_email: Yup.string().email().required("Please Enter Your Email"),
      // businessno: Yup.string()
      //   .min(2, "Enter Business contact")
      //   .required("Please Enter Your Business contact"),
      merchant_mobile: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Enter Business Mobile Number")
        .required("Please Enter Your Business Mobile Number"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
        )
        .required("Please Enter Your password"),
      image: Yup.mixed().test("fileSize", "File size is too large", (value) => {
        // Check the file size (if required)
        // Modify the limit according to your requirements
        return value ? value.size <= 5000000 : true;
      }),
    }),

    onSubmit: (values) => {
      const formData = new FormData();
      if (values.image) {
        formData.append("image", values.image);
      }

      server
        .post("/merchantregister/register", values, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success("User Register successfully");
              navigate("/loginmerchant");
              resetForm();
            }
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else {
            toast.error(error.response.data.error);
          }
        });
    },
  });

  const sendOTPRequest = () => {
    const tst = toast.loading("Sending OTP", {
      theme: "colored",
      type: "info",
    });

    server
      .post("/otp/generate-otp", { email: values.merchant_email })
      .then((res) => {
        if (res.status === 200) {
          setOtpSent(true);
          toast.update(tst, {
            type: "success",
            render: res.data.message,
            isLoading: false,
            autoClose: 4000,
          });
        }
      })
      .catch((err) => {
        console.log(err.message);
        toast.update(tst, {
          type: "error",
          render: "Some Error Occurred",
          isLoading: false,
          autoClose: 4000,
        });
      });
  };

  const verifyOtp = (e) => {
    const tst = toast.loading("Verifying OTP", {
      theme: "colored",
      type: "info",
    });
    server
      .post("/otp/verify-otp", {
        email: values.merchant_email,
        otp: values.otp,
      })
      .then((res) => {
        if (res.status === 200) {
          setOtpVerified(true);
          setStep(2);
        }
        toast.update(tst, {
          type: "success",
          render: res.data.message,
          isLoading: false,
          autoClose: 4000,
        });
      })
      .catch((err) => {
        console.log(err.message);

        toast.update(tst, {
          type: "error",
          render: err.response.data.message,
          isLoading: false,
          autoClose: 4000,
        });

        // toast.error("Some Error Occured");
      });
  };

  const sendOTP = () => {
    // Assuming you want to send OTP only if the email is valid
    if (!errors.email) {
      sendOTPRequest();
    }
  };

  return (
    <>
      {console.log(values)}
      {console.log(errors)}

      <section className="" style={{ marginTop: "1rem" }}>
        <div className="container py-5 ">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col col-xl-10">
              <div className="card" style={{ borderRadius: "1rem" }}>
                <div className="row g-0">
                  <div className="col-md-5">
                    <img
                      src="https://gumlet.assettype.com/down-to-earth%2Fimport%2Fdte%2Fuserfiles%2Fimages%2F5-marathwada-farmer.jpg"
                      alt="login form"
                      className="img-fluid"
                      // height={800}
                      // width={450}
                      style={{ borderRadius: "1rem 0 0 1rem" }}
                    />
                  </div>
                  <div className="col-md-7 d-flex align-items-center">
                    <div className="card-body p-4 p-lg-5 text-black">
                      <div>
                        <h5
                          className="fw-normal mb-3 pb-3 text-center text-uppercase"
                          style={{ letterSpacing: 1 }}
                        >
                          Create your account
                        </h5>
                        <form onSubmit={handleSubmit}>
                          <div className="mb-2">
                            <TextField
                              name="merchant_name"
                              margin="dense"
                              type="text"
                              placeholder="Merchant Name"
                              variant="outlined"
                              label="Merchant Name"
                              value={values.merchant_name}
                              onChange={handleChange}
                              fullWidth
                              required
                            ></TextField>
                            {errors.merchant_name ? (
                              <p className="text-danger">
                                {errors.merchant_name}
                              </p>
                            ) : null}
                          </div>

                          <div className="mb-2">
                            <label htmlFor="">
                              Business Shop Act/Pan Card/Udyam
                            </label>
                            <input
                              name="image"
                              margin="dense"
                              type="file"
                              className="form-control"
                              onChange={(event) => {
                                setFieldValue(
                                  "image",
                                  event.currentTarget.files[0]
                                );
                              }}
                              fullWidth
                              required
                            />
                            {errors.image ? (
                              <p className="text-danger">{errors.image}</p>
                            ) : null}
                          </div>
                          <Row>
                            <Col md={10}>
                              <div className="mb-2">
                                <TextField
                                  name="merchant_email"
                                  margin="dense"
                                  type="email"
                                  placeholder="example@gmail.com"
                                  variant="outlined"
                                  label="Business Email"
                                  value={values.merchant_email}
                                  onChange={handleChange}
                                  fullWidth
                                  required
                                ></TextField>
                                {errors.merchant_email ? (
                                  <p className="text-danger">
                                    {errors.merchant_email}
                                  </p>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={2}>
                              <button
                                // style={{ fontSize: "13px", width: "6rem" }}
                                className="mt-2 btn btn-primary text-white p-1 border-0 rounded-3 btn-sm"
                                type="submit"
                                onClick={(e) => {
                                  e.preventDefault();
                                  sendOTPRequest();
                                }}
                                disabled={otpSent} // Disable button if OTP has already been sent
                              >
                                {otpSent ? "Resend OTP" : "Send OTP"}
                              </button>
                            </Col>
                          </Row>
                          {otpSent && !otpVerified && (
                            <Row>
                              <Col md={9}>
                                <div className="mb-2">
                                  <TextField
                                    name="otp"
                                    margin="dense"
                                    type="text"
                                    placeholder="Enter Otp"
                                    variant="outlined"
                                    label="Otp"
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                  />
                                </div>
                              </Col>
                              <Col md={3}>
                                <button
                                  className="mt-3 btn btn-success text-white border-0 rounded-3 align-self-center"
                                  type="submit"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    verifyOtp(true);
                                  }}
                                >
                                  Verify
                                </button>
                              </Col>
                            </Row>
                          )}

                          <div className="mb-2">
                            <TextField
                              name="merchant_mobile"
                              margin="dense"
                              type="text"
                              placeholder="Business Contact Number"
                              variant="outlined"
                              label="Business Contact Number"
                              value={values.merchant_mobile}
                              onChange={handleChange}
                              fullWidth
                              required
                            ></TextField>
                            {errors.merchant_mobile ? (
                              <p className="text-danger">
                                {errors.merchant_mobile}
                              </p>
                            ) : null}
                          </div>
                          {otpVerified && (
                            <div className="mb-2">
                              <TextField
                                name="password"
                                margin="dense"
                                type="password"
                                placeholder="Password"
                                variant="outlined"
                                label="Password"
                                value={values.password}
                                onChange={handleChange}
                                fullWidth
                                required
                              ></TextField>
                              {errors.password ? (
                                <p className="text-danger">{errors.password}</p>
                              ) : null}
                            </div>
                          )}

                          <div className="text-center">
                            <button
                              className="banner border-0 p-2 mt-2 w-100 rounded-5 text-white "
                              type="submit"
                            >
                              Register
                            </button>
                            <p className="mt-2">
                              I already have an account ?
                              <NavLink to="/loginmerchant"> Login</NavLink>
                            </p>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MerchantRegister;
